export enum MovementTypeEnum {
    Income,
    Expense,
}